import {
  isScreeningRelatedTemplate,
  TRIGGER_TEMPLATES,
  EVALUATION_TEMPLATES,
} from '../../../constants/alkymation';
import ScreeningStrategy from './ScreeningStrategy';
import DefaultStrategy from './DefaultStrategy';
import ConditionCheckStrategy from './ConditionCheckStrategy';

class ModalStrategyFactory {
  static strategies = new Map();

  static registerStrategies() {
    if (!this.strategies?.has('screening')) {
      this.strategies?.set('screening', new ScreeningStrategy());
    }
    if (!this.strategies?.has('condition-check')) {
      this.strategies?.set('condition-check', new ConditionCheckStrategy());
    }
    if (!this.strategies?.has('default')) {
      this.strategies?.set('default', new DefaultStrategy());
    }
  }

  static getStrategy(node) {
    this.registerStrategies();

    if (isScreeningRelatedTemplate({ node })) {
      return this.strategies?.get('screening');
    }

    if (node?.templateId === 'condition-check') {
      return this.strategies?.get('condition-check');
    }

    return this.strategies?.get('default');
  }

  static getStrategyByTemplateId(templateId) {
    this.registerStrategies();

    const screeningTemplateIds = [
      TRIGGER_TEMPLATES.WEBHOOK_SCREENING_COMPLETE,
      EVALUATION_TEMPLATES.ASSESSMENT_INVITATION,
    ];

    if (screeningTemplateIds?.includes(templateId)) {
      return this.strategies?.get('screening');
    }

    if (templateId === 'condition-check') {
      return this.strategies?.get('condition-check');
    }

    return this.strategies?.get('default');
  }
}

export default ModalStrategyFactory;
